import styles from "./SrOnly.module.scss"
import { SrOnlyProps } from "./SrOnly.types"

export default function SrOnly(props: SrOnlyProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
